import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-confirm-delete-modal',
    templateUrl: './confirm-delete-modal.component.html',
    styleUrls: ['./confirm-delete-modal.component.css']
})
export class ConfirmDeleteModalComponent {
    @Input() postId!: number; // Post ID to delete (optional)
    @Output() confirm = new EventEmitter<void>(); // Emit when confirmed
    @Output() cancel = new EventEmitter<void>(); // Emit when canceled

    onConfirm(): void {
        this.confirm.emit(); // Emit confirm event
    }

    onCancel(): void {
        this.cancel.emit(); // Emit cancel event
    }
}
